import { render, staticRenderFns } from "./UOttawaLabExamPt2Fr.vue?vue&type=template&id=33981e7f&scoped=true&"
import script from "./UOttawaLabExamPt2Fr.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabExamPt2Fr.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaLabExamPt2Fr.vue?vue&type=style&index=0&id=33981e7f&prod&lang=css&"
import style1 from "./UOttawaLabExamPt2Fr.vue?vue&type=style&index=1&id=33981e7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33981e7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
